// assets/wellness-beliefs.js

document.addEventListener('DOMContentLoaded', function() {
  // Initialize AOS (Animate On Scroll) if available
  if (typeof AOS !== 'undefined') {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      easing: 'ease-out-cubic'
    });
  } else {
    // Fallback animation implementation
    initCustomAnimations();
  }

  // Parallax effect for floating elements
  initParallaxEffect();

  // Badge hover effects
  initBadgeEffects();

  // Progressive image loading
  initProgressiveImageLoading();

  // Smooth scroll for CTA button if it links to an anchor
  initSmoothScroll();
});

/**
 * Custom animation implementation if AOS is not available
 */
function initCustomAnimations() {
  const animatedElements = document.querySelectorAll('[data-aos]');
  
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -100px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('aos-animate');
        
        // Add delay if specified
        const delay = entry.target.getAttribute('data-aos-delay');
        if (delay) {
          entry.target.style.transitionDelay = delay + 'ms';
        }
      }
    });
  }, observerOptions);

  animatedElements.forEach(element => {
    observer.observe(element);
  });
}

/**
 * Parallax effect for floating elements
 */
function initParallaxEffect() {
  const floatingElements = document.querySelectorAll('.floating-element');
  
  if (floatingElements.length === 0) return;

  let ticking = false;

  function updateParallax() {
    const scrolled = window.pageYOffset;
    
    floatingElements.forEach((element, index) => {
      const speed = index % 2 === 0 ? 0.5 : 0.3;
      const yPos = -(scrolled * speed);
      const rotation = scrolled * 0.2;
      
      element.style.transform = `translateY(${yPos}px) rotate(${rotation}deg)`;
    });

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  window.addEventListener('scroll', requestTick);
}

/**
 * Interactive badge effects
 */
function initBadgeEffects() {
  const badges = document.querySelectorAll('.wellness-badge');
  
  badges.forEach(badge => {
    // Add ripple effect on hover
    badge.addEventListener('mouseenter', function(e) {
      const icon = this.querySelector('.wellness-badge__icon');
      if (!icon) return;

      // Create ripple element
      const ripple = document.createElement('span');
      ripple.className = 'badge-ripple';
      
      // Calculate position
      const rect = icon.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      
      ripple.style.width = ripple.style.height = size + 'px';
      ripple.style.left = '50%';
      ripple.style.top = '50%';
      
      icon.appendChild(ripple);
      
      // Remove ripple after animation
      setTimeout(() => {
        ripple.remove();
      }, 600);
    });

    // Add tilt effect on mousemove
    badge.addEventListener('mousemove', function(e) {
      const rect = this.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      
      const deltaX = (x - centerX) / centerX;
      const deltaY = (y - centerY) / centerY;
      
      this.style.transform = `
        perspective(1000px)
        rotateY(${deltaX * 10}deg)
        rotateX(${-deltaY * 10}deg)
        translateZ(10px)
      `;
    });

    badge.addEventListener('mouseleave', function() {
      this.style.transform = '';
    });
  });
}

/**
 * Progressive image loading with blur effect
 */
function initProgressiveImageLoading() {
  const images = document.querySelectorAll('.wellness-beliefs__image-container img');
  
  images.forEach(img => {
    // Skip if already loaded
    if (img.complete) return;

    // Add loading class
    img.classList.add('image-loading');
    
    // Create blur overlay
    const overlay = document.createElement('div');
    overlay.className = 'image-loading-overlay';
    img.parentElement.appendChild(overlay);

    // Handle image load
    img.addEventListener('load', function() {
      setTimeout(() => {
        this.classList.remove('image-loading');
        overlay.style.opacity = '0';
        
        setTimeout(() => {
          overlay.remove();
        }, 300);
      }, 100);
    });

    // Handle error
    img.addEventListener('error', function() {
      this.classList.remove('image-loading');
      overlay.remove();
    });
  });
}

/**
 * Smooth scroll for anchor links
 */
function initSmoothScroll() {
  const ctaButton = document.querySelector('.wellness-beliefs__button');
  
  if (!ctaButton) return;

  ctaButton.addEventListener('click', function(e) {
    const href = this.getAttribute('href');
    
    // Check if it's an anchor link
    if (href && href.startsWith('#')) {
      e.preventDefault();
      
      const target = document.querySelector(href);
      if (target) {
        const offset = 80; // Adjust for fixed header if needed
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    }
  });
}

/**
 * Add CSS for ripple effect
 */
const style = document.createElement('style');
style.textContent = `
  .badge-ripple {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    transform: translate(-50%, -50%) scale(0);
    animation: ripple 0.6s ease-out;
    pointer-events: none;
  }

  @keyframes ripple {
    to {
      transform: translate(-50%, -50%) scale(4);
      opacity: 0;
    }
  }

  .image-loading {
    filter: blur(5px);
    transform: scale(1.1);
  }

  .image-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, #B2DAF4 0%, #0d86c9 100%);
    opacity: 0.3;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }

  .wellness-badge {
    transition: transform 0.2s ease;
    transform-style: preserve-3d;
  }
`;
document.head.appendChild(style);

/**
 * Performance optimization: Debounce scroll events
 */
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

/**
 * Add intersection observer for performance
 */
function initLazyFeatures() {
  const section = document.querySelector('.wellness-beliefs');
  if (!section) return;

  const observerOptions = {
    root: null,
    rootMargin: '200px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Load heavy features only when section is visible
        entry.target.classList.add('section-visible');
        
        // Initialize interactive features
        if (!entry.target.hasAttribute('data-initialized')) {
          entry.target.setAttribute('data-initialized', 'true');
          
          // Add any heavy initialization here
          console.log('Wellness beliefs section initialized');
        }
      }
    });
  }, observerOptions);

  observer.observe(section);
}

// Initialize lazy loading
initLazyFeatures();